(() => {
  function openModal(modal, modalImg, modalTitle, modalDesc, data) {
    if (!modal || !data) return;

    modalTitle.textContent = data.title;
    modalDesc.innerHTML = data.description;

    if (data.image) {
      modalImg.src = data.image;
      modalImg.alt = data.title;
      modalImg.style.display = 'block';
    } else {
      modalImg.style.display = 'none';
    }

    modal.showModal();
    document.body.classList.add('overflow-hidden');
  }

  function setActiveIndex(root, index) {
    root.querySelectorAll('.component-marker__hotspot').forEach((hotspot) => {
      hotspot.classList.toggle('is-highlighted', hotspot.dataset.index === index);
    });
    root.querySelectorAll('.component-marker__tag').forEach((tag) => {
      tag.classList.toggle('is-active', tag.dataset.index === index);
    });
  }

  function clearActive(root) {
    root.querySelectorAll('.component-marker__hotspot.is-highlighted').forEach((el) => {
      el.classList.remove('is-highlighted');
    });
    root.querySelectorAll('.component-marker__tag.is-active').forEach((el) => {
      el.classList.remove('is-active');
    });
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const blockData = JSON.parse(root.dataset.blocks || '{}');
    const modal = root.querySelector('.component-marker__modal');
    const modalClose = modal && modal.querySelector('.component-marker__modal-close');
    const modalImg = root.querySelector('[data-modal-image]');
    const modalTitle = root.querySelector('[data-modal-title]');
    const modalDesc = root.querySelector('[data-modal-description]');
    const hotspots = root.querySelectorAll('.component-marker__hotspot');
    const tags = root.querySelectorAll('.component-marker__tag');

    function showDetail(index) {
      const data = blockData[index];
      if (!data) return;
      setActiveIndex(root, index);
      openModal(modal, modalImg, modalTitle, modalDesc, data);
    }

    hotspots.forEach((hotspot) => {
      const index = hotspot.dataset.index;

      hotspot.addEventListener('mouseenter', () => setActiveIndex(root, index));
      hotspot.addEventListener('mouseleave', () => {
        if (!modal || !modal.open) clearActive(root);
      });
      hotspot.addEventListener('click', () => showDetail(index));
    });

    tags.forEach((tag) => {
      const index = tag.dataset.index;

      tag.addEventListener('mouseenter', () => setActiveIndex(root, index));
      tag.addEventListener('mouseleave', () => {
        if (!modal || !modal.open) clearActive(root);
      });
      tag.addEventListener('click', () => showDetail(index));
    });

    if (modalClose) {
      modalClose.addEventListener('click', () => modal.close());
    }

    if (modal) {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });

      modal.addEventListener('close', () => {
        document.body.classList.remove('overflow-hidden');
        clearActive(root);
      });
    }

    root.dataset.initialized = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-component-marker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-component-marker]');
    if (root) {
      delete root.dataset.initialized;
      init(root);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-component-marker]');
    if (root) delete root.dataset.initialized;
  });
})();
